import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BsArrowDownCircle } from 'react-icons/bs'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import BasicInfo from './propertyView/BasicInfo'
import Photo from './propertyView/Photo'
import UploadDocument from './propertyView/UploadDocument'
import Address from './propertyView/Address'
import { isEmpty } from 'lodash'
import { BiArrowBack } from 'react-icons/bi'
import AuthContext from 'context/AuthContext'

function PropertyViewListNew () {
  const { setTab } = useContext(AuthContext)
  const location = useLocation()
  const navigate = useNavigate()
  const [showCollapse, setShowCollapse] = useState({ tabNo: 0 })
  const [propertyData, setPropertyData] = useState()

  const [propertyCategoryType, setPropertyCategoryType] = useState([])

  const propertyId = location?.state?.propertyId

  const fetchProperties = async () => {
    const path = `${apiPath.propertyDetailsById}?propertyId=${propertyId}`
    const result = await apiGet(path)
    const response = result?.data?.results
    setPropertyData(response)
  }
  const fetchMasterRecords = async data => {
    try {
      const payload = { ...data }
      const path = apiPath.PropertiesMasterData
      const result = await apiGet(path, payload)
      const records = result?.data?.results

      if (isEmpty(propertyCategoryType)) {
        setPropertyCategoryType([records?.propertyCategories[0]?._id] || [])
      }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }

  const basicInfo = {
    property_type: propertyData?.propertyType ?? 'N/A',
    property_category: propertyData?.propertyCategory ?? 'N/A',
    slug: propertyData?.slug ?? 'N/A',
    slugAr: propertyData?.slugAr ?? 'N/A',
    bedrooms: propertyData?.bedrooms ?? 'N/A',
    bathrooms: propertyData?.bathrooms ?? 'N/A',
    guestRooms: propertyData?.guestRooms ?? 'N/A',
    livingRooms: propertyData?.livingRooms ?? 'N/A',
    maidsRoom: propertyData?.maidsRoom ?? '',
    driverRoom: propertyData?.driverRoom ?? '',
    title: propertyData?.title ?? 'N/A',
    titleAr: propertyData?.titleAr ?? 'N/A',
    sub_title: propertyData?.sub_title ?? 'N/A',
    sub_titleAr: propertyData?.sub_titleAr ?? 'N/A',
    plot_size: propertyData?.propertySize ?? 'N/A',
    price: propertyData?.price ?? 'N/A',
    bua: propertyData?.bua ?? 'N/A',
    serviceCharge: propertyData?.serviceCharge ?? 'N/A',
    pricePerUnit: propertyData?.pricePerUnit ?? 'N/A',
    cheques: propertyData?.cheques ?? 'N/A',
    securityDeposit: propertyData?.securityDeposit ?? 'N/A',
    priceDaily: propertyData?.priceDaily ?? 'N/A',
    priceMonthly: propertyData?.priceMonthly ?? 'N/A',
    priceWeekly: propertyData?.priceWeekly ?? 'N/A',
    priceYearly: propertyData?.priceYearly ?? 'N/A',
    readyStage: propertyData?.readyStage ?? 'N/A',
    stage: propertyData?.stage ?? 'N/A',
    parking: propertyData?.parking ?? 'N/A',
    financialStatus: propertyData?.financialStatus ?? 'N/A',
    referenceNumber: propertyData?.referenceNumber ?? 'N/A',
    furnished: propertyData?.furnished ?? 'N/A',
    constructionStatus: propertyData?.constructionStatus ?? 'N/A',
    permitNumber: propertyData?.permitNumber ?? 'N/A',
    agent: propertyData?.agent ?? 'N/A',
    advert_type: propertyData?.advertType ?? 'N/A',
    advert_typeAr: propertyData?.advertTypeAr ?? 'N/A',
    layout_type: propertyData?.layoutType ?? 'N/A',
    layout_typeAr: propertyData?.layoutTypeAr ?? 'N/A',
    no_of_floors: propertyData?.totalFloors ?? 'N/A',
    floor_number: propertyData?.floorNumber,
    parkingType: propertyData?.parkingType,
    description: propertyData?.description,
    projectStatus: propertyData?.projectStatus,
    descriptionAr: propertyData?.descriptionAr,
    metaDescription: propertyData?.metaDescription,
    metaDescriptionAr: propertyData?.metaDescriptionAr,
    metaTitle: propertyData?.metaTitle,
    metaTitleAr: propertyData?.metaTitleAr,
    keywordAr: propertyData?.keywordAr,
    keyword: propertyData?.keyword,
    amenities : propertyData?.amenities,
    owner_name : propertyData?.owner_name,
    owner_email : propertyData?.owner_email,
    owner_phone : propertyData?.owner_phone,
    agreementStatus : propertyData?.agreementStatus,
    handOverDate : propertyData?.handOverDate,
  }

  const address = {
    city: propertyData?.city ?? 'N/A',
    country: propertyData?.country ?? 'N/A',
    community: propertyData?.community ?? 'N/A',
    subCommunity: propertyData?.subCommunity ?? 'N/A',
    street: propertyData?.street ?? 'N/A',
    streetInfoFour: propertyData?.streetInfoFour ?? 'N/A',
    streetInfoThree: propertyData?.streetInfoThree ?? 'N/A',
    streetInfoTwo: propertyData?.streetInfoTwo ?? 'N/A',
    streetInfoOne: propertyData?.streetInfoOne ?? 'N/A',
    propertyAge: propertyData?.propertyAge ?? 'N/A',
    propertyWidth: propertyData?.propertyWidth ?? 'N/A',
    propertyLength: propertyData?.propertyLength ?? 'N/A',
    streetWidth: propertyData?.streetWidth ?? 'N/A',
    building: propertyData?.building ?? 'N/A',
    unit_number: propertyData?.unitNumber ?? 'N/A',
    near_facility: propertyData?.nearestFacility,
    near_facilityAr: propertyData?.nearestFacilityAr,
    location: propertyData?.location,
    locationImage: propertyData?.locationImage
  }
  const photos = {
    threeSixtyView: propertyData?.threeSixtyView,
    video_url: propertyData?.videoUrl,
    photos: propertyData?.photos,
    videos: propertyData?.video,
    floor_plan: propertyData?.floorPlan
  }
  const documents = {
    documents: propertyData?.documents
  }

  const collapseCheck = tabNo => {
    if (tabNo === showCollapse.tabNo) {
      setShowCollapse({ tabNo: 0 })
    } else {
      setShowCollapse({ tabNo })
    }
  }

  useEffect(() => {
    fetchMasterRecords()
    const tab = location?.state?.tab
    setTab(tab)
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    fetchProperties()
    // eslint-disable-next-line
  }, [propertyId])
  return (
    <>
      <div className='relative pt-6 pl-6 pr-6 pb-6 flex  items-center justify-between border-b-2'>
        <div className='text-base sm:text-lg lg:text-xl font-medium'>
          Property View Details
        </div>
        <div
          className='flex justify-start items-center cursor-pointer mr-2'
          onClick={() => navigate(-1)}
        >
          {/* <AiOutlineHome onClick={()=>navigate('/')} className='cursor-pointer' /> / <span onClick={()=>navigate(-1)} className='cursor-pointer' >Property Manager</span> */}
          {/* <AiOutlineHome /> / Property Manager */}
          <BiArrowBack className='h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer' />
          <span className='mb-2 ml-2'>Go Back</span>
        </div>
      </div>

      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <div className='m-2 border border-black-500 '>
              <div
                className={`${
                  showCollapse?.tabNo === 1 && 'bg-gray-100'
                } flex  items-center justify-between border-b p-6 cursor-pointer`}
                onClick={() => collapseCheck(1)}
              >
                <div className='text'>Basic Info</div>
                <div
                  className={`${
                    showCollapse?.tabNo === 1 && 'rotate-180 '
                  } transform transition-transform duration-500`}
                >
                  <BsArrowDownCircle />
                </div>
              </div>
              <div className=''>
                {showCollapse?.tabNo === 1 ? (
                  <BasicInfo items={propertyData} />
                ) : null}
              </div>
            </div>
            <div className='m-2 border border-black-500 '>
              <div
                className={`${
                  showCollapse?.tabNo === 2 && 'bg-gray-100'
                } flex  items-center justify-between border-b p-6 cursor-pointer`}
                onClick={() => collapseCheck(2)}
              >
                <div className='text'>Address</div>
                <div
                  className={`${
                    showCollapse?.tabNo === 2 && 'rotate-180 '
                  } transform transition-transform duration-500`}
                >
                  <BsArrowDownCircle />
                </div>
              </div>
              <div className=''>
                {showCollapse?.tabNo === 2 ? <Address items={address} /> : null}
              </div>
            </div>
            <div className='m-2 border border-black-500 '>
              <div
                className={`${
                  showCollapse?.tabNo === 3 && 'bg-gray-100'
                } flex cursor-pointer items-center justify-between border-b p-6`}
                onClick={() => collapseCheck(3)}
              >
                <div className='text'>Photos/Videos</div>
                <div
                  className={`${
                    showCollapse?.tabNo === 3 && 'rotate-180 '
                  } transform transition-transform duration-500`}
                >
                  <BsArrowDownCircle />
                </div>
              </div>
              <div className=''>
                {showCollapse?.tabNo === 3 ? <Photo items={photos} /> : null}
              </div>
            </div>
            <div className='m-2 border border-black-500'>
              <div
                className={`${
                  showCollapse?.tabNo === 4 && 'bg-gray-100'
                } flex  cursor-pointer items-center justify-between border-b p-6`}
                onClick={() => collapseCheck(4)}
              >
                <div className='text'>Upload Documents</div>
                <div
                  className={`${
                    showCollapse?.tabNo === 4 && 'rotate-180 '
                  } transform transition-transform duration-500`}
                >
                  <BsArrowDownCircle />
                </div>
              </div>
              <div className=''>
                {showCollapse?.tabNo === 4 ? (
                  <UploadDocument items={documents} />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PropertyViewListNew
